
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/cyberark-alternative",
      function () {
        return require("private-next-pages/compare/cyberark-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/cyberark-alternative"])
      });
    }
  